<template lang="pug">
.barcode-card
    VueBarcode(:value="cardNumber" :width="width" :height="height" background="#ffffff" lineColor="#1E1A34" display-value="false" format="EAN13" flat=true)
    p {{formatCode(cardNumber)}}
</template>

<script setup>
    import { ref, computed } from 'vue'
    import VueBarcode from 'vue3-barcode'

    const props = defineProps({
        cardNumber: {
            type: String,
            default: ''
        },
    })
    /** @type {Ref<number>} */
    const width = ref(2.5)
    /** @type {Ref<number>} */
    const height = ref(66)
    const barcodeCardNumber = computed(() => props.cardNumber.slice(0, 12))

    const formatCode = (s) => {
        return s.length === 13 ? s.replace(/^(.{4})(.{4})(.{5})$/, "$1-$2-$3") : s
    }
</script>

<style scoped lang="stylus">
.barcode-card
    text-align: center
    justify-content: center
</style>
